import { useState, useEffect } from "react";

export function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    function(event) {
      console.log(event.target.type, event.target.name, event.target.id)      
      if (event.target.type === "radio") {
        // console.log(event.target.name + '('+event.target.id+')' + '->' + event.target.value)
        setValues({
          ...fields,
          [event.target.name]: event.target.value,
          [event.target.id]: event.target.value
        });
      } else {
        // console.log(event.target.id + '->' + event.target.value)
        setValues({
          ...fields,
          [event.target.id]: event.target.value
        });
      }
    },
    function() {
      setValues(initialState)
    }
  ];
};

export function useScript(url) {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [url]);
};